module.exports = __webpack_public_path__ + "62ba09e6bb300c1b5f68f4eafe72586b.svg";